import Popover from '@mui/material/Popover';
import CommentBox from './CommentBox';
import { ReviewableAction, useActionContext, useCommentContext } from '../../providers';

type Props = {
    readonly anchorEl?: HTMLElement | null;
};

const CommentBoxPopover = ({ anchorEl }: Props) => {
    const { submitComments } = useCommentContext();
    const { reset, hasAction } = useActionContext();

    const onClose = () => {
        submitComments();
        reset(ReviewableAction.Comment);
    };

    return (
        <Popover
            id='comment-box-popover'
            anchorEl={anchorEl}
            open={hasAction(ReviewableAction.Comment)}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}
        >
            <CommentBox />
        </Popover>
    );
};


export default CommentBoxPopover;
